import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

export function DiagnosticNameCell(props: GridRenderCellParams<DeviceStatusOverviewData>) {
  return <>{props.formattedValue || "---"}</>;
}
